import { render, staticRenderFns } from "./api-section-list.vue?vue&type=template&id=50ad3db9&"
import script from "./api-section-list.vue?vue&type=script&lang=js&"
export * from "./api-section-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports